import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CashMovementHistory } from "../../../types/cash/movement";

interface CashMovementState {

    movements: CashMovementHistory[];

    loading: boolean;

}

const initialState: CashMovementState = {

    movements: [],

    loading: false

};

const cashMovementSlice = createSlice({

    name: "cashMovement",

    initialState,

    reducers: {

        /**
         * 📜 Set movimientos
         */
        setMovements(state, action: PayloadAction<CashMovementHistory[]>) {

            state.movements = action.payload;

        },

        /**
         * ⏳ Loading
         */
        setLoading(state, action: PayloadAction<boolean>) {

            state.loading = action.payload;

        },

        /**
         * 🧹 Clear movimientos
         */
        clearMovements(state) {

            state.movements = [];

        }

    }

});

export const {

    setMovements,
    setLoading,
    clearMovements

} = cashMovementSlice.actions;

export default cashMovementSlice.reducer;